
/* injects from baggage-loader */

'use strict';

import TypeIt from 'typeit';

import { definitonModal } from '_appRoot/index.const'

export default class DialogBallonsController {
    constructor($scope, $log, $timeout, $element, $compile) {
        'ngInject';
        this.$log = $log;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$element = $element;
        this.$compile = $compile;

        this.state = {
            step: 0
        }

        this.definitonModal = definitonModal

        this.typeIt = null;
    }
    
    $onInit(){        
        this.$scope.$watch('$ctrl.visible', newVal => {
            if(newVal) this.$timeout(this.triggerTypeIt.bind(this));
        });
    }

    nextDialog(){
        if (this.state.step >= (this.dialogs.length - 1)) {
            return this.onClose();
        } 

        this.state.step++;

        this.$timeout(this.triggerTypeIt.bind(this, true));
    }

    triggerTypeIt(reload){
        if (this.typeIt && !reload) return
        
        let typeItElement = angular.element(this.$element).find('.typewriter');
        
        if(this.static){
            typeItElement.removeClass('idle');
            return false;
        }

        this.typeIt = new TypeIt(typeItElement, {
            speed: 30,
            startDelay: 200,
            afterComplete: () => {
                if(this.autoclose){
                    this.$timeout(this.onClose.bind(this), 800);
                }
            }
        }, false);
        
        typeItElement.removeClass('idle');

        this.typeIt.init();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/dialog-ballons/dialog-ballons.controller.js